const home1 = "https://shpeuf.s3.amazonaws.com/public/home/home-1.jpg"; 
const home2 = "https://shpeuf.s3.amazonaws.com/public/home/home-2.jpg";
const home3 = "https://shpeuf.s3.amazonaws.com/public/home/home-3.jpg";

export {home1, home2, home3}
